module.exports = __webpack_public_path__ + "static/media/59.ffd2abf9.png";